import store from "@/store";

import Navbar from "@/layout/Navbar.vue";
import Sidebar from "@/layout/Sidebar.vue";

/**
 *  beforeEnter Navigation guards 
 *  ihasAuth
 */
 const hasAuth = (to, from, next) => {
    let isLoggedIn = store.getters["auth/isLoggedIn"];
    if (to.params.id && !isLoggedIn) {
        return next("/login");
    }
    next();
    
};

const settlementRoutes = [
    {
        path: "/settlements",
        name: "Settlements",
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "Settlements" */ "@/views/Settlements/Settlements.vue"
                ),
        },
        props: { main: { settlementType: "all" } },
        meta: {
            authentication: false,
            title: "settlements.heading"
        },
    },

    {
        path: "/settlements/mea-maa",
        name: "settlements-mea-maa",
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "Settlements" */ "@/views/Settlements/Settlements.vue"
                ),
        },
        props: { main: { settlementType: "mea_maa" } },
        meta: {
            authentication: false,
            title: "settlements.heading_mea_maa"
        },
    },

    {
        path: "/settlements/kday",
        name: "settlements-kday",
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "Settlements" */ "@/views/Settlements/Settlements.vue"
                ),
        },
        props: { main: { settlementType: "kday" } },
        meta: {
            authentication: false,
            title: "settlements.heading_kday"
        },
    },

    {
        path: "/settlements/xyta",
        name: "settlements-xyta",
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "Settlements" */ "@/views/Settlements/Settlements.vue"
                ),
        },
        props: { main: { settlementType: "xyta" } },
        meta: {
            authentication: false,
            title: "settlements.heading_xyta"
        },
    },

    {
        path: "/settlements/sma",
        name: "settlements-sma",
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "Settlements" */ "@/views/Settlements/Settlements.vue"
                ),
        },
        props: { main: { settlementType: "sma" } },
        meta: {
            authentication: false,
            title: "settlements.heading_sma"
        },
    },
    {
        path: "/settlements/meva",
        name: "settlements-meva",
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "Settlements" */ "@/views/Settlements/Settlements.vue"
                ),
        },
        props: { main: { settlementType: "meva" } },
        meta: {
            authentication: false,
            title: "settlements.heading_meva"
        },
    },

    {
        path: "/settlement/:id",
        name: "Settlement",
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "Settlement" */ "@/views/Settlements/Settlement.vue"
                ),
        },
        props: { main: true },
        meta: {
            authentication: false,
        },
    },

    {
        path: "/settlement-log/:id",
        name: "SettlementPreviewLog",
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "SettlementPreviewLog" */ "@/views/Settlements/SettlementPreviewLog.vue"
                ),
        },
        props: { main: true },
        meta: {
            authentication: false,
        },
    },

    {
        path: "/inactive-settlements",
        name: "InactiveSettlements",
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "InactiveSettlements" */ "@/views/Settlements/InactiveSettlements.vue"
                ),
        },
        meta: {
            authentication: true,
        },
    },

    {
        path: "/deleted-settlements",
        name: "DeletedSettlements",
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "DeletedSettlements" */ "@/views/Settlements/DeletedSettlements.vue"
                ),
        },
        meta: {
            authentication: true,
        },
    },

    {
        path: "/deactivated-settlements",
        name: "DeactivatedSettlements",
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "DeactivatedSettlements" */ "@/views/Settlements/DeactivatedSettlements.vue"
                ),
        },
        meta: {
            authentication: true,
        },
    },

    {
        path: "/settlement-create-edit/:id?",
        name: "settlementCreateEdit",
        beforeEnter: hasAuth,
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "settlementCreateEdit" */ "@/views/Settlements/SettlementCreateEdit.vue"
                ),
        },
        props: { main: true },
        meta: {
            authentication: false,
        },
    },
];

export default settlementRoutes
